export class SubMenus {
  static readonly SITES = '/sites';
  static readonly ADMIN = '/admin';
  static readonly TOOLS = '/tools';
}